import { PitcherSessionReportChartConfigDto, PitcherSessionStatsByPitchTypeChartDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const disabledVisibleStats: (keyof PitcherSessionStatsByPitchTypeChartDto)[] = ['pitchType'];

const PitcherSessionStatsByPitchTypeChartSidebar = (props: ChartConfigProps<TableChartConfigDto, PitcherSessionReportChartConfigDto>) => {
  return (
    <TableChartSidebar
      chartId='PitcherSessionStatsByPitchTypeChart'
      chartKey='pitcherSessionStatsByPitchTypeChartConfig'
      {...props}
      disabledVisibleStats={disabledVisibleStats}
    />
  );
};

export default PitcherSessionStatsByPitchTypeChartSidebar;
